import { createFileRoute } from "@tanstack/react-router";

import TeamDetailPage from "~/pages/friends/TeamDetailPage.tsx";

export const Route = createFileRoute("/_auth/friends/teams/$teamId/")({
    component: TeamDetailPage,
});
